(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["zs-carte-produit"] && !Shopify.designMode) return;
  try {
    /* ZS · Carte produit : effet quand on appuie. Pose data-appui="carte | image | titre | bouton" sur la carte
     touchée (seule cette zone réagit) ; au clic, la zone reste enfoncée jusqu'au chargement de la fiche. */
  (function () {
    if (window.zsCarteAppui) return;
    window.zsCarteAppui = true;

    var carte = null;
    var zone = null;
    var minuteur = null;

    function clicSimple(e) {
      return !(e.defaultPrevented || e.button > 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey);
    }

    function trouver(cible) {
      var z = cible instanceof Element ? cible.closest('[data-zs-carte-appui]') : null;
      var c = z ? z.closest('.zs-carte--appui-zone') : null;
      return c ? { carte: c, zone: z } : null;
    }

    function marquer() {
      clearTimeout(minuteur);
      if (carte && zone) carte.setAttribute('data-appui', zone.getAttribute('data-zs-carte-appui'));
    }

    function lacher() {
      clearTimeout(minuteur);
      carte = null;
      zone = null;
      document.querySelectorAll('.zs-carte[data-appui]').forEach(function (c) {
        c.removeAttribute('data-appui');
      });
    }

    function relache(e) {
      window.removeEventListener('pointerup', relache, true);
      window.removeEventListener('pointercancel', relache, true);
      if (!zone) return;
      if (e.type === 'pointercancel' || !(e.target instanceof Node) || !zone.contains(e.target)) {
        lacher();
        return;
      }
      /* Tape rapide : l'effet s'affiche quand même ; le clic qui suit le prolonge. */
      marquer();
      minuteur = setTimeout(lacher, 200);
    }

    /* Doigt ou souris posé sur une carte : au doigt, court délai pour qu'un défilement n'allume rien. */
    document.addEventListener('pointerdown', function (e) {
      if (!e.isPrimary || e.button > 0) return;
      var t = trouver(e.target);
      if (!t) return;
      lacher();
      carte = t.carte;
      zone = t.zone;
      minuteur = setTimeout(marquer, e.pointerType === 'mouse' ? 0 : 100);
      window.addEventListener('pointerup', relache, true);
      window.addEventListener('pointercancel', relache, true);
    });

    /* Clic : la zone reste enfoncée jusqu'à l'affichage de la fiche produit. */
    document.addEventListener('click', function (e) {
      var t = trouver(e.target);
      if (!t || !clicSimple(e)) return;
      if (carte && carte !== t.carte) lacher();
      clearTimeout(minuteur);
      carte = t.carte;
      zone = t.zone;
      marquer();
      minuteur = setTimeout(lacher, 2500);
    });

    document.addEventListener('contextmenu', lacher);
    /* Retour arrière : la page revient du cache du navigateur avec la carte encore enfoncée. */
    window.addEventListener('pageshow', lacher);
  })();
  } catch(e) { console.error(e); }
})();

})();
